module.exports = __webpack_public_path__ + "static/media/155-credit-card.c81611d2.svg";